import clsx from 'clsx';
import { HTMLAttributes } from 'react';

export const Unknown = ({ className }: HTMLAttributes<HTMLDivElement>) => (
  <div className={clsx('flex items-center justify-center', className)}>
    Preview not available
  </div>
);
